<template>
<div>
	<!-- если нет никаких ошибок -->
	<template v-if="!form_ErrorMessage">

		<!-- заголовок -->
		<h3 :class="{ 'form-title': qrCode }">{{ formData.title | ftc }}</h3>

		<!-- информация по платежам -->
		<div v-if="action === 'select'" class="w5-block-bordered cp">
			<p v-withSafeTags="localeFtc('operation/bonus_information')" class="w5-block-bordered-text"></p>
		</div>

		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				{{ localErrorMessage | ftc }}
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
			</div>
		</transition>

		<!-- если это форма -->
		<template v-if="form_GetData['status'] === 'form'">

			<!-- если есть инструкция -->
			<div v-if="form_GetData['template']" v-html="form_GetData['template']" style="margin: 20px 0" />
			
			<!-- форма редактирования -->
			<form class="w5-from outer-form" ref="mainFormForPay"
				:action="form_GetData['action'] ? form_GetData['action'] : null"
				:method="form_GetData['method'] ? form_GetData['method'] : null">
			<fieldset :disabled="form_Loading">

				<!-- поля -->
				<div v-for="(row, index) in formData.fields" v-if="row"
					:key="index"
					:class="{
						'w5-form-row': isVisibleField(row),
						'divider-field': isDividerField(row)
					}">
					<Field v-for="field in row"
						:key="field._field_name"
						:isVisibleRow="isVisibleField(row)"
						:objID="id"
						:crud="crud"
						:action="action"
						:Field="field"
						:listBlockToOut="true"

						:bigButton="field._field_name === 'fake_2_1'"
						:bigButtonTitle="field._field_name === 'fake_2_1' ? 'operation/pay' : null"
						:bigButtonHandler="field._field_name === 'fake_2_1' ? onEnterKeyDown : null"
						:bigButtonEnabled="field._field_name === 'fake_2_1' && isSubmitButtonEnabled"

						:linkButton="field._field_name === 'fake_2_2'"
						:linkButtonTitle="field._field_name === 'fake_2_2' ? 'paymentauto/update_title' : null"
						:linkButtonUrl="'/paymentauto/create'"
						:linkButtonVisible="showAutoPaymentButton"

						v-model="field.value"
						@valueChanged="fieldChanged(field)"
						@blur="onBlur(field)"
						@focus="onFocus(field)"
						@enterKeyDown="onEnterKeyDown"
						@operationNextStep="onClientCreateOperation"
						@deleteSavedPayment="onDeleteSavedPayment"
						/>
				</div>

				<!-- кнопка -->
				<div class="w5-field">
					<button v-if="action === 'pay'"
						type="button"
						ref="submit_button"
						@click="submitForm"
						:disabled="buttonBlock > 0 ? 'disabled' : false"
						class="btn btn-submit btn-primary w5-button-save"
						:class="{ hidden: form_Loading }">
						{{ 'operation/pay' | ftc }}
					</button>
				</div>

				<!-- кнопка выбора оплаты -->
				<div v-if="action === 'pay' && !isPayLocked" class="select-pay1">
					<span @click.stop="goToSelect" class="w5-link linkified" :class="{ hidden: form_Loading }">
						<font-awesome-icon icon="arrow-left" />
						{{ 'operation/select_title' | ftc }}
					</span>
				</div>

			</fieldset></form>

			<!-- сслыка на внешную форму -->
			<div v-if="!isExternalForm && isHashField" class="payment-link-wrapper">
				<!-- text -->
				<strong>{{ 'operation/payment_link_description' | ftc }}</strong>
				<!-- link -->
				<div style="margin: 2px 0">
					<a ref="paymentLinkUrl" :href="paymentLinkUrl" target="_blank" class="payment-link">{{ paymentLinkUrl }}</a>
					<font-awesome-icon icon="copy" :title="'main/copy_to_clipboard' | ftc" @click="copyPaymentLink" />
				</div>
			</div>

			<!-- диалог создание плательщика -->
			<transition name="modal">
				<div v-show="showPayerDialogModal" @click="hidePayerDialogModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'payer/payer' | ftc }}</span>
								<button type="button" class="close" @click="hidePayerDialogModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
							<div class="alert alert-warning margin-0">
								<p class="padding-0-5" v-withSafeTags="localeFtc('payer/new_alert')"></p>
							</div>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-in-dialog" @click="goToCreatePayer">{{ 'payer/create_title' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>

			<!-- диалог удаления записи -->
			<transition name="modal">
				<div v-show="showDeleteModal" @click="hideDeleteModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'main/deleting' | ftc }}</span>
								<button type="button" class="close" @click="hideDeleteModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body"><p class="padding-0-5" v-withSafeTags="deleteModalText"></p></div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" :disabled="deleteModalTimer && deleteModalTimer > 0 ? 'disabled' : false" @click="deleteModalCallback">{{ deleteButtonTitle }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>

		</template>
		<!-- если это страница печати -->
		<template v-else-if="form_GetData['status'] === 'ok'">

			<!-- разделитель -->
			<div style="padding: 5px 0; border-bottom: 1px solid #eee;"></div>

			<!-- QR-код -->
			<div v-if="qrCode" class="w5-form-row">
				<img v-if="qrCode" :src="qrCode" class="qr-image" :class="{ 'ext': !$store.state.is_auth }" />
			</div>

			<!-- реквизиты -->
			<div v-for="(row, index) in formData.fields" v-if="row" :key="index" :class="{ 'w5-form-row': isVisibleField(row) }">
				<div v-for="field in row"
					:key="field._field_name"
					v-if="field.type !== 'hidden' && field.type !== 'fake' && field.type !== 'image'"
					style="padding: 5px 0; border-bottom: 1px solid #eee; width: 100%">
					<span style="width: 100px; font-weight: 500;" v-if="field.type !== 'fake'">{{ field.title | ftc }}:</span>
					<br><span v-if="field._field_name !== 'summ'" v-withSafeTags="localeFtc(field.value)"></span>
					<span v-else>{{ parseFloat(field.value).toFixed(2) | money }} <span v-html="localeFtc('main/ruble')"> </span></span>
				</div>
			</div>

			<!-- кнопка показа документа -->
			<span v-if="form_GetData && form_GetData.html" class="w5-modal-link order-link" @click="openDocumentModalDialog(form_GetData.html, form_GetData.pdf)">
				<div class="attach-no-image-preview">HTML</div>{{ localeFtc('main/open') + ' ' + localeFtc('document/document').toLowerCase() }}
			</span>

			<a v-if="form_GetData && form_GetData.pdf" :href="form_GetData.pdf" download="download" class="order-link">
				<div class="attach-no-image-preview">PDF</div>{{ 'operation/bill_pdf' | ftc }}
			</a>

			<a v-if="form_GetData && form_GetData.link" :href="form_GetData.link" download="download" class="order-link fas">
				<font-awesome-icon icon="comment-dollar" /> {{ 'operation/pay' | ftc }}
			</a>

			<!-- диалог показа документа -->
			<div v-show="showDocumentModalDialog" @click="hideDocumentModalDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container for-document" @click.stop>
						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'document/document' | ftc }}</span>
							<button type="button" class="close" @click="hideDocumentModalDialog">&times;</button>
						</div>
						<!-- тело диалога -->
						<div class="modal-body">
							<div class="document-wrapper">
								<iframe width="100%" frameborder="0" id="documentFrame" name="documentFrame" seamless>
									Ваш браузер не поддерживает показ документа
								</iframe>
							</div>
						</div>
						<!-- подвал -->
						<div class="modal-footer">
							<span v-if="isPrintReady" class="btn btn-submit pull-left" @click="documentPrint">{{ 'main/print' | ftc }}</span>
							<a v-if="documentModalDialogLink" :href="documentModalDialogLink" class="btn btn-submit pull-right" download="download">{{ 'main/download' | ftc }}</a>
						</div>
					</div>
				</div>
			</div>

			<!-- кнопка выбора оплаты -->
			<div v-if="action === 'pay'" class="select-pay2" :class="{ 'back-without-links': !form_GetData || (!form_GetData.html && !form_GetData.pdf) }">
				<span @click.stop="goToSelect" class="w5-link linkified" :class="{ hidden: form_Loading }">
					<font-awesome-icon icon="arrow-left" />
					{{ 'operation/select_title' | ftc }}
				</span>
			</div>

			<!-- сслыка на внешную форму -->
			<br>
			<div v-if="!isExternalForm && isHashField" class="payment-link-wrapper">
				<!-- text -->
				<strong>{{ 'operation/payment_link_description' | ftc }}</strong>
				<!-- link -->
				<div style="margin: 2px 0">
					<a ref="paymentLinkUrl" :href="paymentLinkUrl" target="_blank" class="payment-link">{{ paymentLinkUrl }}</a>
					<font-awesome-icon icon="copy" :title="'main/copy_to_clipboard' | ftc" @click="copyPaymentLink" />
				</div>
			</div>

		</template>

		<!-- общий диалог -->
		<transition name="modal">
			<div v-show="showGeneralDialog" @click="hideGeneralDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ generalDialogTitle | ftc }}</span>
							<button type="button" class="close" @click="hideGeneralDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body"><p class="padding-0-5" v-withSafeTags="generalDialogText"></p></div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" :class="{ 'btn-submit-danger': generalDialogButtonStyle === 1 }" :disabled="generalDialogTimer && generalDialogTimer > 0 ? 'disabled' : false" @click="generalDialogCallback">{{ generalDialogButtonTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

	</template>

	<errorAlert v-else :message="form_ErrorMessage" />
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Field from '@/components/elements/formfield'
import Helper from '@/helper/helper'
import { EventBus } from '@/bus.js'
import $ from 'jquery'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'clientPayComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['items', 'value'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// CRUD
			crud: null,
			// Действие
			action: null,
			// ID платежа
			id: null,

			// данные формы
			formData: {
				title: ' '
			},

			// блокировка кнопки
			buttonBlock: 0,

			// сообщение об ошибке
			localErrorMessage: '',

			// данные в виде FormData
			FD: false,
			FD_count: 0,

			// ссылка на внешную форму
			paymentLinkUrl: '',

			// QR-код
			qrCode: null,

			// диалог показа документа
			showDocumentModalDialog: false,
			documentModalDialogLink: null,

			// диалог создания плательщика
			showPayerDialogModal: false,

			// диалог удаления
			showDeleteModal: false,
			deleteModalValue: null,
			deleteModalText: '',
			deleteButtonTitle: '',
			deleteModalTimer: null,
			deleteModalTimerHandler: null,

			// общий диалог
			showGeneralDialog: false,
			generalDialogTitle: '',
			generalDialogText: '',
			generalDialogButtonStyle: 0,
			generalDialogCallback: () => {},
			generalDialogButtonTitle: '',
			generalDialogTimer: 0,
			generalDialogTimerHandler: null
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// доступен объект window?
		isPrintReady() {
			return window && window.print
		},
		isExternalForm() {
			// получим id операции
			let _id = this.$route.params.id
			if (!_id) return false
			// если id это хеш - запомним его в sessionStorage
			if (/^[a-z0-9]+$/.test(_id) && _id.length > 12) return true
			// по умолчанию это не внешняя форма
			return false
		},
		isHashField() {
			if (this.formData &&
				this.formData.fields &&
				Array.isArray(this.formData.fields) &&
				this.formData.fields.length)
			{
				return this.formData.fields.some(item => {
					if (item && item._field_name === 'external_hash' && item.value)
						return true
					else if (item && Array.isArray(item) && item.length)
					{
						let _found = item.some(fld => {
							if (fld && fld._field_name === 'external_hash' && fld.value)
								return true
						})
						if (_found) return true
					}
				})
			}

			return false
		},
		isSubmitButtonEnabled() {
			if (this.action !== 'select') return true

			let _savedField = this.findField('saved')
			let _paymentField = this.findField('payment')

			if (_savedField && _savedField.value) return true
			if (_paymentField && _paymentField.value) return true

			return false
		},
		// кнопка редиректа в создание автоплатежа
		showAutoPaymentButton() {
			let _savedField = this.findField('saved')
			if (_savedField && _savedField.list && _savedField.list.length)
			{
				return true
			}

			return false
		},
		isPayLocked() {
			if (this.action !== 'pay') return false

			if (this.form_GetData && this.form_GetData['paylock'] === true) return true

			return false
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// проверка индентификатора
		if (!this.$route || !this.$route.params || !this.$route.params.id)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// сброс URL
			this.$store.commit('setReturnURL', false)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// получим id операции
		let _id = this.$route.params.id
		// если id это хеш - запомним его в sessionStorage
		if (/^[a-z0-9]+$/.test(_id) && _id.length > 12)
		{
			window.sessionStorage.setItem('operation_hash', _id)
		}
		else
		{
			// если это числовой индентификатор - то после запроса будет редирект автоматом
			// так как АПИ сервер вернет код 401 (неавторизованный пользователь)
		}

		// инициализация начальных данных по URL
		this.initData(this.$route.path)

		// теперь можно запросить данные
		if (this.crud) this.requestData()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		EventBus.$on('w5-payment-bank-legal', this.bankLegalPaySubmit)
		EventBus.$on('w5-show-payer-dialog', this.showPayerDialog)
		EventBus.$on('w5-redirect', this.redirectHandler)
		document.addEventListener('keydown', this.keyDownHandler)
		window.addEventListener('resize', this.windowResize)

		// сразу идет установка размера окна диалога документа
		this.windowResize()
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		EventBus.$off('w5-payment-bank-legal', this.bankLegalPaySubmit)
		EventBus.$off('w5-show-payer-dialog', this.showPayerDialog)
		EventBus.$off('w5-redirect', this.redirectHandler)
		document.removeEventListener('keydown', this.keyDownHandler)
		window.removeEventListener('resize', this.windowResize)

		if (this.deleteModalTimerHandler) clearInterval(this.deleteModalTimerHandler)
	},
	//=========================================================================
	// локальные методы формы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие всех диалогов по ESC
			if (e.keyCode === 27)
			{
				this.hideDocumentModalDialog()
				this.hidePayerDialogModal()
				this.hideDeleteModal()
			}
		},
		//---------------------------------------------------------------------
		// печать формы
		//---------------------------------------------------------------------
		printData(e) {
			// отмена дальнейшего действия
			e.preventDefault()
			// получаем шаблон
			let html = this.form_GetData['template'] ? this.form_GetData['template'] : ''
			// заменяем в шаблоне переменные
			for (let k in this.form_GetData['fields']) if (this.form_GetData['fields'].hasOwnProperty(k))
			{
				// получим значение
				let _val = this.form_GetData['fields'][k].value ? this.localeFtc(this.form_GetData['fields'][k].value) : ''
				// отформатируем его
				if (this.form_GetData['fields'][k].type === 'money') _val = Helper.MoneyForPrint(_val)
				// подставим в шаблон
				html = html.replace(new RegExp('{' + k + '}', 'g'), _val)
			}
			// открываем шаблон в новом окошке
			let _w = window.open()
			_w.document.open()
			_w.document.write(html)
			_w.document.close()
		},
		//---------------------------------------------------------------------
		// диалог удаления
		//---------------------------------------------------------------------
		// кликнули по доп.кнопке fontawesomeButton
		onDeleteSavedPayment(id) {
			if (!id) return

			if (this.deleteModalTimerHandler) clearInterval(this.deleteModalTimerHandler)
			this.deleteModalTimer = 5
			this.deleteModalText = ''
			this.deleteButtonTitle = this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)

			// ищем поле
			let _savedIdField = this.findField('saved')
			if (!_savedIdField || typeof _savedIdField !== 'object' || !_savedIdField.list || !_savedIdField.list.length) return

			// запомним ID
			this.deleteModalValue = id

			// текст диалога
			let showValue = id
			_savedIdField.list.some(item => {
				if (item && item.id === showValue)
				{
					showValue = item.name
					return true
				}
			})
			this.deleteModalText = this.localeFtc('main/delete_msg').replace('{name}', showValue)

			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true

			this.deleteModalTimerHandler = setInterval(() => {
				this.deleteModalTimer--
				this.deleteButtonTitle = this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)

				if (this.deleteModalTimer <= 0)
				{
					this.deleteButtonTitle = this.localeFtc('main/delete')
					clearInterval(this.deleteModalTimerHandler)
					this.deleteModalTimerHandler = null
				}
			}, 1000)
		},
		// закрыть диалог
		hideDeleteModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showDeleteModal = false
			this.hideModalMask()
		},
		// клик по кнопке диалога - подтверждение
		deleteModalCallback() {
			// если таймер еще не закончился
			if (this.deleteModalTimer > 0) return

			// если не задан ID
			if (this.deleteModalValue === undefined || this.deleteModalValue === null || this.deleteModalValue <= 0) return

			// обнуляем значения
			this.localErrorMessage = ''

			// закрыть диалог
			this.hideDeleteModal()

			// ищем поле
			let _savedIdField = this.findField('saved')
			if (!_savedIdField || typeof _savedIdField !== 'object' || !_savedIdField.list || !_savedIdField.list.length)
			{
				this.localErrorMessage = 'error/required_field'
				return
			}

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/operation/delete?additional=setDeleteSaved&saved_id=' + this.deleteModalValue
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// готовим данные POST
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									let msg = 'payment/deleted'
									if (_dt['title']) msg = _dt['title']
									// покадем сообщение об успехе
									EventBus.$emit('w5-notificator-add', {
										'title': ' ',
										'message': msg,
										'class': 'success',
										'type': 'nourl',
										'id': 'success-message',
										'timeout': 3000
									})
									// удалим из списка локально
									if (_savedIdField.list && _savedIdField.list.length)
									{
										_savedIdField.list.some((item, idx) => {
											if (item && item.id === this.deleteModalValue)
											{
												_savedIdField.list.splice(idx, 1)
												return true
											}
										})
									}
									// на это все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// диалог создания плательщика
		//---------------------------------------------------------------------
		hidePayerDialogModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showPayerDialogModal = false
			this.hideModalMask()
		},
		// переход в форму создания плательщика
		goToCreatePayer() {
			// закрываем форму
			this.hidePayerDialogModal()
			// переходим в форму создания
			this.$router.push('/payer/create')
		},
		// показываем диалог по событию
		showPayerDialog() {
			EventBus.$emit('w5-body-scroll-disable')
			this.showPayerDialogModal = true
		},
		//---------------------------------------------------------------------
		// подтверждение формы
		//---------------------------------------------------------------------
		submitForm(e) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если форма залочена
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.buttonBlock > 0) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// сразу лочим кнопку
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.buttonBlock <= 0) this.buttonBlock = 1

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это выбор способа оплаты
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.action === 'select')
			{
				// бежим по всем полям
				let _rows = this.formData['fields']
				// если полей нет
				if (!_rows || !Array.isArray(_rows))
				{
					this.localErrorMessage = 'error/app_internal'
					this.buttonBlock = 0
					return
				}

				// данные для передачи
				let _data = this.collectData(_rows)
				// если данные по каким либо причинам собрать не удалось
				if (_data === false)
				{
					this.buttonBlock = 0
					return
				}

				//-------------------------------------------------------------
				// найдем выбранный способ платежа
				//-------------------------------------------------------------
				if (e !== 'nextStep2')
				{
					let _paymentCase = null
					let _isSaved = false

					// проверим оплату сохраненным способом
					let _savedField = this.findField('saved')
					if (_savedField &&
						_savedField.list && _savedField.list.length &&
						'value' in _savedField &&
						_savedField['value'] !== null && _savedField['value'] !== undefined &&
						_savedField._visible === true)
					{
						// найдем данные платежа
						_savedField.list.some(f => {
							if (String(f.id) === String(_savedField.value))
							{
								_paymentCase = f
								_isSaved = true
								return true
							}
						})
					}

					// так же проверим оплату другим способом - если еще не нашли
					if (!_paymentCase)
					{
						let _paymentField = this.findField('payment')
						if (_paymentField &&
							_paymentField.list && _paymentField.list.length &&
							'value' in _paymentField &&
							_paymentField['value'] !== null && _paymentField['value'] !== undefined &&
							_paymentField._visible === true)
						{
							// найдем данные платежа
							_paymentField.list.some(f => {
								if (String(f.id) === String(_paymentField.value))
								{
									_paymentCase = f
									_isSaved = false
									return true
								}
							})
						}
					}

					// если нашли такой способ
					if (_paymentCase)
					{
						// убираем блокировку
						this.buttonBlock = 0

						// ищем сумму операции
						let _curSumma = 0
						let _smField = this.findField('summa')
						if (_smField && 'value' in _smField) _curSumma = parseFloat(_smField.value)
						if (isNaN(_curSumma) || _curSumma < 0) _curSumma = 0

						// посчитаем общую сумму к списанию
						let _com = _paymentCase['comission']
						if (_com === undefined || _com === null || isNaN(_com) || _com === '') _com = 0
						_com = parseFloat(_com)
						let _price = (_curSumma + _com * _curSumma / 100.0).toFixed(2)
						_price = parseFloat(_price)

						// формируем текст
						let _text = this.localeFtc('operation/payment_info')
							.replace('{saved}', _isSaved ? ' (сохранённый)' : '')
							.replace('{name}', _paymentCase['name'] ? this.localeFtc(_paymentCase['name']) : 'обычный')
							.replace('{com}', Helper.FormatMoney2(_com, 2))
							.replace('{sum}', Helper.FormatMoney2(_price, 2))
							.replace('{val}', this.localeFtc('main/ruble')) +
							'<br><br>' +
							this.localeFtc('operation/payment_warning')

						// покажем сумму
						this.generalDialogShow(
							'main/refresh_screen',
							_text,
							this.localeFtc('main/continue'),
							() => {
								this.hideGeneralDialog()
								this.submitForm('nextStep2')
							}
						)

						// дальше только через кнопку "Продолжить"
						return
					}
				}

				//-------------------------------------------------------------
				// данные собраны - отправляем их
				//-------------------------------------------------------------
				let _url = this.$route.path
				// старт запроса
				this.$http.get(this.APIServerUrl + _url).then(
					// успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model'])
						{
							// второй запрос - POST
							// переупакуем данные: NameForm[data[disk]] => NameForm[data][disk]
							_data = this.FD_rePack(_data)

							// готовим данные
							let _post = {
								'_csrf': _dt['_csrf']
							}
							_post[_dt['model']] = _data

							// готовим данные в виде FormData
							this.FD = new FormData()
							this.FD_count = 0
							this.FD_prepare(_post)

							// производим сам запрос
							this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(
								// успешный ответ сервера
								resPost => {
									// получим данные ответа
									_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false

									// если ошибки нет
									if (_dt && (_dt['status'] === 'ok' || _dt['status'] === 'redirect'))
									{
										// если есть поле "title" и оно имеет значение - "уже оплачено"
										if ('title' in _dt && _dt.title === 'operation/already_paid')
										{
											// если пользователь авторизован
											if (this.$store.state.is_auth)
											{
												// редиректим на список платежей
												return this.$router.push('/operation/list')
											}
											// пользователь неавторизован
											else
											{
												// получим хеш
												let hash = window && window.sessionStorage ? window.sessionStorage.getItem('operation_hash') : null
												// если хеш есть
												if (hash)
												{
													// редирект в просмотр
													return this.$router.push('/operation/view/' + hash)
												}
												// если хеша нет
												else
												{
													// делаем редирект на логин
													return this.$router.push('/login')
												}
											}
										}

										// если есть статус и задан URL
										if (_dt.status === 'redirect' && 'url' in _dt && String(_dt.url).length)
										{
											// редиректим на внешний URL
											let url = _dt.url
											if (url[0] !== '/') url = '/' + url
											return this.$router.push(url)
										}

										// на этом все
										this.buttonBlock = 0
										return
									}

									// пришла какая то ошибка
									if (_dt && _dt['status'] === 'error')
									{
										// если есть ошибки по полям
										if (_dt['fields'])
										{
											for (let k in _dt['fields'])
											{
												if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length)
												{
													let _field = this.findField(k)
													if (_field) _field['_errMsg'] = this.localeFtc(_dt['fields'][k].join(' <br> '))
												}
											}
										}
										// на этом все
										this.buttonBlock = 0
										return
									}

									// иная ошибка
									this.localErrorMessage = 'error/api_incorrect'
									this.buttonBlock = 0
								},
								// отрицательный ответ сервера
								resPost => {
									// ошибка
									this.localErrorMessage = 'error/api_incorrect'
									this.buttonBlock = 0
								}
							)

							// на этом все
							return
						}

						// ошибка
						this.localErrorMessage = 'error/api_incorrect'
						this.buttonBlock = 0
					},
					// отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = 'error/api_incorrect'
						this.buttonBlock = 0
					}
				)
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это непосредственно оплата
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (this.action === 'pay')
			{
				// если это внешняя форма
				if (this.form_GetData['status'] === 'form' &&
					this.form_GetData['method'] &&
					this.form_GetData['action'] &&
					!this.form_GetData['model'])
				{
					let _rows = this.formData['fields']
					// если полей нет
					if (!_rows || !Array.isArray(_rows))
					{
						this.localErrorMessage = 'error/app_internal'
						this.buttonBlock = 0
						return
					}

					// данные для передачи
					let _data = this.collectData(_rows)
					// если данные по каким либо причинам собрать не удалось
					if (_data === false) return

					// нужно время на построение формы
					setTimeout(() => {
						// получаем форму
						let $form = $(this.$refs['mainFormForPay'])
						// если форма есть
						if ($form.length)
						{
							// для того что бы передались все поля - заенаблим дизабленные поля
							// и получим типы
							$form.find(':disabled').each(function(e) {
								let _type = false
								let _span = $(this).parent().children('span[data-input-type]:first')
								if (_span.length) _type = _span.data('input-type')
								if (_type === 'money' || _type === 'float') $(this).val(Helper.Str2Float($(this).val()))
								else if (_type === 'int' || _type === 'integer') $(this).val(Helper.Str2Int($(this).val()))

								$(this).attr('readonly', 'readonly').removeAttr('disabled')
							})

							// захайдим форму - просто уберем ее влево
							$form.css({ 'left': '-2000px' })

							// теперь нужно залочить операцию
							// старт запроса
							const _url = this.APIServerUrl + `/operation/pay/${this.id}?additional=setPayLock`
							this.$http.get(_url).then(
								// успешный GET ответ сервера
								resGet => {
									let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
									if (_dt && _dt['_csrf'])
									{
										// второй запрос - POST
										let _post = {
											'_csrf': _dt['_csrf']
										}

										// производим сам запрос
										this.$http.post(_url, Helper.toFormData(_post)).then(
											// успешный ответ сервера
											resPost => {
												// получим данные ответа
												_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
												// если ошибки нет
												if (_dt && _dt['status'] === 'ok')
												{
													// теперь просто сабмитим форму
													$form.submit()

													// на этом все
													this.buttonBlock = 0
													return
												}

												// иная ошибка
												this.localErrorMessage = 'error/api_incorrect'
												this.buttonBlock = 0
											},
											// отрицательный ответ сервера
											() => {
												// ошибка
												this.localErrorMessage = 'error/api_incorrect'
												this.buttonBlock = 0
											}
										)

										// на этом все
										return
									}

									// ошибка
									this.localErrorMessage = 'error/api_incorrect'
									this.buttonBlock = 0
								},
								// отрицательный GET ответ сервера
								() => {
									this.localErrorMessage = 'error/api_incorrect'
									this.buttonBlock = 0
								}
							)
						}
					}, 500)
				}
				// если это внутренняя форма
				else if (this.form_GetData['status'] === 'form' &&
					!this.form_GetData['method'] &&
					!this.form_GetData['action'] &&
					this.form_GetData['model'] &&
					this.form_GetData['_csrf'])
				{
					let _rows = this.formData['fields']
					// если полей нет
					if (!_rows || !Array.isArray(_rows))
					{
						this.localErrorMessage = 'error/app_internal'
						this.buttonBlock = 0
						return
					}

					// данные для передачи
					let _data = this.collectData(_rows)
					// если данные по каким либо причинам собрать не удалось
					if (_data === false) return
					// переупакуем данные: NameForm[data[disk]] => NameForm[data][disk]
					_data = this.FD_rePack(_data)

					// данные собраны - отправляем их
					let _url = this.$route.path

					// готовим POST данные
					let _post = {
						'_csrf': this.form_GetData['_csrf']
					}
					_post[this.form_GetData['model']] = _data

					// готовим данные в виде FormData
					this.FD = new FormData()
					this.FD_count = 0
					this.FD_prepare(_post)

					// производим сам запрос
					this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(
						// успешный ответ сервера
						resPost => {
							let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false

							// если ошибки нет
							if (_dt && (_dt['status'] === 'ok' || _dt['status'] === 'redirect'))
							{
								// если есть поле "title" и оно имеет значение - "уже оплачено"
								if ('title' in _dt && _dt.title === 'operation/already_paid')
								{
									// если пользователь авторизован
									if (this.$store.state.is_auth)
									{
										// редиректим на список платежей
										return this.$router.push('/operation/list')
									}
									// пользователь неавторизован
									else
									{
										// получим хеш
										let hash = window && window.sessionStorage ? window.sessionStorage.getItem('operation_hash') : null
										// если хеш есть
										if (hash)
										{
											// редирект в просмотр
											return this.$router.push('/operation/view/' + hash)
										}
										// если хеша нет
										else
										{
											// делаем редирект на логин
											return this.$router.push('/login')
										}
									}
								}

								// если есть статус и задан URL
								if (_dt.status === 'redirect' && 'url' in _dt)
								{
									// редиректим на внешний URL
									return this.$router.push('/' + _dt.url)
								}

								// на этом все
								this.buttonBlock = 0
								return
							}

							// пришла какая то ошибка
							if (_dt && _dt['status'] === 'error')
							{
								// если есть ошибки по полям
								if (_dt['fields'])
								{
									for (let k in _dt['fields'])
									{
										if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length)
										{
											let _field = this.findField(k)
											if (_field) _field['_errMsg'] = this.localeFtc(_dt['fields'][k].join(' <br> '))
										}
									}
								}
								// на этом все
								this.buttonBlock = 0
								return
							}

							// иная ошибка
							this.localErrorMessage = this.formatRequestError(resPost)
							this.buttonBlock = 0
						},
						// отрицательный ответ сервера
						resPost => {
							// ошибка
							this.localErrorMessage = this.formatRequestError(resPost)
							this.buttonBlock = 0
						}
					)
				}
				else if (this.form_GetData['status'] === 'error')
				{
					let _msg = 'error/api_incorrect'
					if ('title' in this.form_GetData && this.form_GetData['title']) _msg = this.form_GetData['title']
					if ('content' in this.form_GetData && this.form_GetData['content']) _msg = this.form_GetData['content']
					this.localErrorMessage = _msg
					this.buttonBlock = 0
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// инициализация начальных данных
		//---------------------------------------------------------------------
		initData(path) {
			// обнуляем основные значения
			this.crud = null
			this.action = null
			this.id = null
			this.localErrorMessage = ''
			this.buttonBlock = 0
			this.paymentLinkUrl = ''

			// парсим входящий URL
			let _urlParts = path
				.substr(path.charAt(0) === '/' ? 1 : 0)
				.split('/')
			// должны быть ровно три части
			if (_urlParts.length !== 3 ||
				!_urlParts[0] || !_urlParts[0].length ||
				!_urlParts[1] || !_urlParts[1].length ||
				!_urlParts[2] || !_urlParts[2].length)
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// если первая часть это не "operation"
			if (_urlParts[0] !== 'operation')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// если вторая часть это не "pay" и не "select"
			if (_urlParts[1] !== 'pay' && _urlParts[1] !== 'select')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// получим наименование CRUD
			this.crud = _urlParts[0]
			this.action = _urlParts[1]

			// получим ID объекта
			if (_urlParts[2]) this.id = _urlParts[2]
		},
		//---------------------------------------------------------------------
		// запрос данных формы
		//---------------------------------------------------------------------
		requestData() {
			this.$store.commit('needShowLoader', true)
			// URL по умолчанию
			let _url = this.$route.path

			// производим сам запрос формы
			this.forms_Get(_url, false,
				// успешно получили данные
				data => {
					// если сразу пришел редирект
					if (data && data.status === 'redirect' && data.url)
					{
						window.location.replace(data.url)
						return
					}

					// нужно их распарсить
					this.formData = this.parseThisFormData(data)

					// ищем QR-код
					this.qrCode = null
					let _qr = this.findField('image')
					if (_qr && _qr.type === 'image' && _qr.value)
						this.qrCode = _qr.value

					// если есть поле "title" и оно имеет значение - "уже оплачено"
					if ('title' in this.formData && this.formData.title === 'operation/already_paid')
					{
						// если пользователь авторизован
						if (this.$store.state.is_auth)
						{
							// редиректим на список платежей
							return this.$router.push('/operation/list')
						}
						// пользователь неавторизован
						else
						{
							// получим хеш
							let hash = window && window.sessionStorage ? window.sessionStorage.getItem('operation_hash') : null
							// если хеш есть
							if (hash)
							{
								// редирект в просмотр
								return this.$router.push('/operation/view/' + hash)
							}
							// если хеша нет
							else
							{
								// делаем редирект на логин
								return this.$router.push('/login')
							}
						}
					}

					// если есть статус и задан URL
					if ('status' in this.formData && this.formData.status === 'redirect' && 'url' in this.formData)
					{
						// редиректим на внешний URL
						return this.$router.push('/' + this.formData.url)
					}

					// если это выбор способа оплаты
					if (this.action === 'select')
					{
						let _sumField = this.findField('summa')
						if (_sumField && _sumField['value'])
							this.$nextTick(() => EventBus.$emit('form-client-operation-create', _sumField['value']))

						// поле с сохраненными способами платежа
						let _saved = this.findField('saved')
						if (_saved)
							_saved.type = 'savedPayments'
					}

					// если это оплата
					if (this.action === 'pay')
					{
						let _savedIdField = this.findField('saved_id')
						if (_savedIdField)
							_savedIdField.fontawesomeButton = 'trash-alt'
					}

					// вычисляем условия "showif" в следующем тике,
					this.$nextTick(() => {
						this.showif()
					})
				},
				// ошибка
				() => {
					this.localErrorMessage = this.form_ErrorMessage
					this.form_ErrorMessage = false
				}
			)
		},
		//---------------------------------------------------------------------
		// переход в форму выбора оплаты
		//---------------------------------------------------------------------
		goToSelect() {
			if (this.$route && this.$route.params && this.$route.params.id)
				this.$router.push('/operation/select/' + this.$route.params.id)
		},
		//---------------------------------------------------------------------
		// копирование ссылки в буфер обмена
		//---------------------------------------------------------------------
		copyPaymentLink() {
			let el = this.$refs['paymentLinkUrl']
			let ok = Helper.copyToClipboard(el)
			if (ok)
			{
				EventBus.$emit('w5-notificator-add', {
					'title': ' ',
					'message': 'main/copied_to_clipboard',
					'class': 'success',
					'type': 'nourl',
					'id': 'success-message',
					'timeout': 3000
				})
			}
		},
		//---------------------------------------------------------------------
		// фокус на поле
		//---------------------------------------------------------------------
		onFocus(field) {
			// чистим ошибку если есть в самом поле
			field['_errMsg'] = ''

			// нужно почистить ошибки в других полях тоже
			let fieldsNames = ['summa', 'saved', 'payment']

			// чистим сразу во всех этих полях
			fieldsNames.forEach(name => {
				let _field = this.findField(name)
				if (_field)
				{
					_field['_errMsg'] = ''
				}
			})
		},
		//---------------------------------------------------------------------
		// потеря фокуса полем
		//---------------------------------------------------------------------
		onBlur(field) {
			// сделаем проверку на минимальную сумму
			let _min = 999999999
			let _val = parseFloat(field['value'])

			if (!isNaN(_val))
			{
				// 1. в поле "saved" -> list -> min
				let _savedField = this.findField('saved')
				if (_savedField && _savedField.list && _savedField.list.length)
				{
					_savedField.list.forEach(ff => {
						if (ff && 'min' in ff)
						{
							let _minVal = parseFloat(ff['min'])
							if (!isNaN(_minVal) && _minVal < _min) _min = _minVal
						}
					})
				}

				// 2. в поле "payment" -> list -> min
				let _paymentField = this.findField('payment')
				if (_paymentField && _paymentField.list && _paymentField.list.length)
				{
					_paymentField.list.forEach(ff => {
						if (ff && 'min' in ff)
						{
							let _minVal = parseFloat(ff['min'])
							if (!isNaN(_minVal) && _minVal < _min) _min = _minVal
						}
					})
				}

				// 3. если введеное значение меньше минимума
				if (_min < 999999999 && _val < _min)
				{
					// меняем на минимальный минимум с анимацией
					EventBus.$emit('w5-set-money-field-value', {
						'type': field['type'],
						'name': field['_field_name'],
						'value': _min,
						'animation': true
					})
				}
			}
		},
		//---------------------------------------------------------------------
		// нажали ENTER по полю
		//---------------------------------------------------------------------
		onEnterKeyDown(e) {
			if (e) e.preventDefault()
			if (!this.isSubmitButtonEnabled) return
			this.submitForm(e)
		},
		//---------------------------------------------------------------------
		// поменялось значение поля
		//---------------------------------------------------------------------
		fieldChanged(field) {
			// частный случай: если это поле ввода суммы при пополнении
			// баланса клиентов, нужно сделать сообщение
			if (field['_field_name'] === 'summa')
			{
				EventBus.$emit('form-client-operation-create', field['value'])
			}

			// если есть указание обнулить поле
			if (this.action === 'select' && field['unselect'])
			{
				EventBus.$emit('w5-clear-list-field', field['unselect'])
			}

			// если выбрали значение из списка сохраненных способов
			if (field['_field_name'] === 'saved' && field['value'])
			{
				if (this._computedWatchers &&
				this._computedWatchers.isSubmitButtonEnabled &&
				this._computedWatchers.isSubmitButtonEnabled.run)
				{
					this._computedWatchers.isSubmitButtonEnabled.run()
					this.$forceUpdate()
				}
			}

			// каждый раз вычисляем условия "showif" для всех полей с таким условием
			this.showif()
		},
		//---------------------------------------------------------------------
		// вычисляем значение "showif" для всех полей
		//---------------------------------------------------------------------
		showif() {
			// бежим по всем полям
			let _rows = this.formData['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с названиями
						if (field['_field_name'])
						{
							// заполняем объект со значениями
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value']

							// если есть выражение для данного поля
							if (field['showif'])
							{
								// получим выражение
								let _expr = field['showif']
								// подменяем в выражении переменные
								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1)
								{
									// условие: var not in [array]
									if (_expr.indexOf(' not in ') !== -1)
									{
										// var not in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5]) < 0
										let reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0')
										}
										else
										{
											// var[idx] not in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5]) < 0
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') < 0')
											}
										}
									}
									// условие: var in [array]
									else
									{
										// var in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5])
										let reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1')
										}
										else
										{
											// var[idx] in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5])
											reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') !== -1')
											}
										}
									}
								}
								// type[period] == 0    =>    type__period__ == 0
								else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
								_expressions[field['_field_name']] = _expr
							}
						}
					})
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = this.findField(e)
				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		//---------------------------------------------------------------------
		// есть ли видимые поля в строке
		//---------------------------------------------------------------------
		isVisibleField(row) {
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden')
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// это поле-разделитель?
		//---------------------------------------------------------------------
		isDividerField(row) {
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом "header"
			row.some((item, idx, arr) => {
				// если такое поле есть
				if (item && item.type === 'header' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// парсит данные формы
		//---------------------------------------------------------------------
		parseThisFormData: function(data) {
			// инициализируем объект
			let formData = {}

			// если нет данных для парсинга - конец
			if (!data || typeof data !== 'object' || !Object.keys(data).length) return formData

			// есть ли статус
			if (!('status' in data)) return formData

			// допустимый ли статус
			if (data['status'] !== 'form' && data['status'] !== 'ok' && data['status'] !== 'redirect') return formData

			// заголовок
			if ('title' in data) formData['title'] = data['title']
			else formData['title'] = false

			// поля
			if ('fields' in data && data['fields'] && Object.keys(data['fields']).length)
			{
				// есть ли хеш внешнией формы
				if ('external_hash' in data['fields'] && data['fields']['external_hash'] && 'value' in data['fields']['external_hash'] && data['fields']['external_hash']['value'])
				{
					// формируем ссылку
					this.paymentLinkUrl = this.CpServerUrl + '/operation/select/' + data['fields']['external_hash']['value']
				}
				// запомним поля
				if (this.action === 'select') formData['fields'] = Helper.sortByProp(data['fields'], 'order')
				else formData['fields'] = Helper.sortByProp(data['fields'], 'order', true)
			}
			else formData['fields'] = false

			return formData
		},
		//---------------------------------------------------------------------
		// поиск поля в formData
		//---------------------------------------------------------------------
		findField(name) {
			// если нет вообще полей
			if (!this.formData.fields) return null

			// поля есть - пробежимся по ним
			let _field = null
			this.formData.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// клиент выбрал способ оплаты для пополнения баланса
		//---------------------------------------------------------------------
		onClientCreateOperation(id) {
			this.submitForm(id)
		},
		//---------------------------------------------------------------------
		// клиент пытается сделать платежку юр.лица
		//---------------------------------------------------------------------
		bankLegalPaySubmit(id) {
			// ищем поле с плательщиком
			let _payerField = this.findField('payer')

			// если это поле видимо и оно пустое
			if (_payerField && _payerField._visible && (!_payerField.list || !_payerField.list.length))
			{
				EventBus.$emit('w5-show-payer-dialog')
				return
			}

			// если это поле видимо и выбрано какое то значение - только
			// в этом случае идет на следующий шаг
			if (_payerField && _payerField._visible &&
				_payerField.value !== undefined && _payerField.value !== null && _payerField.value !== '')
			{
				//this.submitForm(id)
			}
			else
			{
				// а иначе делаем изменение значения поля способа оплаты
				let _payField = this.findField('payment')
				_payField.value = parseInt(id)
				this.fieldChanged(_payField)
			}
		},
		//---------------------------------------------------------------------
		// модальный диалог показа документа
		//---------------------------------------------------------------------
		// показывает диалог
		openDocumentModalDialog(linkHtml, linkPdf) {
			// проверка данных - ссылка на документ
			if (!linkHtml) return
			// элемент iframe
			let _frm = document ? document.getElementById('documentFrame') : null
			if (!_frm) return
			// обязательно чистим iframe
			_frm.srcdoc = '<html><body></body></html>'
			// и установим размер
			this.windowResize()
			// запоминаем ссылку на PDF
			this.documentModalDialogLink = linkPdf
			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDocumentModalDialog = true
			// начинаем грузить документ
			this.$http.get(linkHtml)
			.then(resGet => {
				let _dt = resGet && resGet.data ? resGet.data : false
				if (!_dt || !_frm) throw new Error()
				_frm.srcdoc = _dt
			})
			.catch(() => {
				_frm.srcdoc = '<html><body>Не удалось получить документ...</body></html>'
			})
		},
		// закрывает диалог
		hideDocumentModalDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showDocumentModalDialog = false
			this.documentModalDialogLink = null
			this.hideModalMask()
			// обязательно чистим iframe
			let _frm = document ? document.getElementById('documentFrame') : null
			if (!_frm) return
			_frm.srcdoc = '<html><body></body></html>'
		},
		// вывод на печать содержимого iframe
		documentPrint() {
			if (window && window.print)
			{
				let frm = document.getElementById('documentFrame').contentWindow
				frm.focus()
				frm.print()
			}
		},
		//---------------------------------------------------------------------
		// вызывает функцию
		//---------------------------------------------------------------------
		windowResize() {
			if (!document || !document.documentElement) return
			let height = document.documentElement.clientHeight - 200
			let frame = document.getElementById('documentFrame')
			if (frame && frame.style)
				frame.style.height = height + 'px'
		},
		//---------------------------------------------------------------------
		// конвертация данных в FormData
		//---------------------------------------------------------------------
		FD_prepare: function(d, key) {
			let k

			for (k in d) if (d.hasOwnProperty(k))
			{
				// если пересылают файл в форме - патч для safari 10+
				if (d[k] && key &&
					k === 'file' &&
					typeof d[k] === 'object' &&
					'name' in d[k] &&
					'size' in d[k] &&
					'type' in d[k])
				{
					this.FD.append(key + '[' + k + ']', d[k])
					this.FD_count++
					continue
				}

				// остальные поля обрабатываем по старому
				if (typeof d[k] === 'object' && d[k] && !('lastModifiedDate' in d[k]))
				{
					if (key)
					{
						this.FD_prepare(d[k], key + '[' + k + ']')
					}
					else
					{
						this.FD_prepare(d[k], k)
					}
				}
				else
				{
					if (key)
					{
						this.FD.append(key + '[' + k + ']', d[k])
					}
					else
					{
						this.FD.append(k, d[k])
					}

					this.FD_count++
				}
			}
		},
		//---------------------------------------------------------------------
		// сбор данных для формы
		//---------------------------------------------------------------------
		collectData(rows) {
			// обнуляем данные
			let data = {}

			// смотрим каждое поле простым циклом - что бы прервать его в любой момент
			for (let idx in rows)
			{
				// если нет значения - пропускаем
				if (!rows[idx] || !Array.isArray(rows[idx])) continue

				// бежим по всей строке формы
				let row = rows[idx]
				for (let k in row)
				{
					// получим объект - поле
					let field = row[k]

					// рассматриваем только поля с наименованиями
					if (!field['_field_name']) continue

					// если есть хотя бы одно поле с ошибкой - прерываем
					if (field['_errMsg'])
					{
						this.buttonBlock = 0
						return false
					}

					// значение по умолчанию
					let _val = field['value']
					// если это "file" или "image"
					if (field['type'] === 'file' || field['type'] === 'image')
					{
						// если есть метка удаления файла
						if (field['_deleteFile'] === true)
						{
							// добавляем еще параметр
							data[field['_field_name'] + '_delete'] = 1
						}
					}

					// если это массив
					if (Array.isArray(field['value']))
					{
						// если это пустой массив
						if (!field['value'].length) _val = null
						else
						{
							// масив имеет значения
							_val = []
							// бежим по нему, для конвертации
							field['value'].forEach(item => {
								// если элемент массива - это объект c id
								if (typeof item === 'object' && item['id'])
								{
									_val.push(item['id'])
								}
								// если простой тип
								else _val.push(item)
							})
						}
					}

					// обязательное поле?
					if (field['required'] === true)
					{
						// если значение вообще не задано
						if (_val === undefined || _val === null || String(_val).trim() === '')
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}

						// если это пустой массив
						if (Array.isArray(_val) && _val.length === 0)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}
					}

					// проверка email
					if (field['type'] === 'email')
					{
						if (!Helper.validateEmail(_val))
						{
							// проверка не пройдена
							field['_errMsg'] = 'validators/error_email'
							this.buttonBlock = 0
							return false
						}
					}

					// игнорируем пустые поля
					if (_val === undefined || _val === null) continue

					// конвертация значения
					if (field['type'] === 'boolean')
						_val = Helper.normalizeBooleanValue(_val) ? 1 : 0

					// все проверки пройдены - запоминаем значение
					data[field['_field_name']] = _val
				}
			}

			// возвращаем полученный ответ
			return data
		},
		//---------------------------------------------------------------------
		// NameForm[data[disk]] => NameForm[data][disk]
		//---------------------------------------------------------------------
		FD_rePack(data) {
			let k
			let n1
			let n2
			let key1
			let key2

			for (k in data) if (data.hasOwnProperty(k))
			{
				n1 = k.indexOf('[')
				if (n1 < 0) continue

				n2 = k.indexOf(']', n1)
				if (n2 < 0) continue

				key1 = k.substr(0, n1)
				key2 = k.substring(n1 + 1, n2)

				if (n2 + 1 < k.length) key2 += k.substr(n2 + 1)

				if (!data[key1]) data[key1] = {}

				data[key1][key2] = data[k]

				delete data[k]

				data[key1] = this.FD_rePack(data[key1])
			}

			return data
		},
		//---------------------------------------------------------------------
		// если пришла команда на редирект
		//---------------------------------------------------------------------
		redirectHandler(data) {
			// проверка данных
			if (!data || !data.id || !data.url) return

			// если мы именно в этой форме
			if (this.id === String(data.id))
			{
				this.$router.push(data.url)
			}
		},
		//---------------------------------------------------------------------
		// общий диалог
		//---------------------------------------------------------------------
		// закрытие диалога
		hideGeneralDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showGeneralDialog = false
			this.hideModalMask()
		},

		// генерация даилога
		generalDialogShow(title, text, buttonTitle, callback = null, style = 0, buttonCounter = false) {
			this.generalDialogTitle = title
			this.generalDialogText = text
			this.generalDialogButtonStyle = style
			this.generalDialogCallback = () => {
				if (this.generalDialogTimer > 0) return
				callback()
			}
			this.generalDialogButtonTitle = buttonTitle

			if (buttonCounter) {
				if (this.generalDialogTimerHandler) clearInterval(this.generalDialogTimerHandler)
				this.generalDialogTimer = 5
				this.generalDialogButtonTitle = '5 - ' + buttonTitle
			}

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showGeneralDialog = true

			// готовим таймер
			if (buttonCounter) {
				this.generalDialogTimerHandler = setInterval(() => {
					this.generalDialogTimer--
					this.generalDialogButtonTitle = this.generalDialogTimer + ' - ' + buttonTitle

					if (this.generalDialogTimer <= 0)
					{
						this.generalDialogButtonTitle = buttonTitle
						clearInterval(this.generalDialogTimerHandler)
						this.generalDialogTimerHandler = null
					}
				}, 1000)
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдаем переходы между CRUD внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			// инициируем основные данные, в частности и this.crud
			this.initData(to.path)

			// теперь можно запросить данные
			if (this.crud) this.requestData()
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
h3.form-title {
	max-width: calc(100% - 200px);
	line-height: 1;
}

.outer-form {
	position: relative;
}

.payment-link-wrapper {
	margin-right: 7px;
	padding: 15px;
	border: 1px solid #eee;
    border-radius: 4px;
}

.payment-link-wrapper svg.fa-copy {
	margin-left: 5px;
	color: #999;
	cursor: pointer;
	transition: color 0.2s;
}
.payment-link-wrapper svg.fa-copy:hover {
	color: #333;
}

.qr-image {
	position: absolute;
    top: 52px;
    right: 10px;
}
.qr-image.ext {
	top: 58px;
}

.select-pay1 {
	margin: 20px 0;
}
.select-pay2 {
	margin: 5px 0;
}

.order-link {
	display: inline-block;
	font-weight: 500;
	margin: 20px 40px 20px 0;
}

.order-link.fas {
	display: none;
	margin-bottom: 10px;
}

.order-link.fas > svg {
	position: relative;
	top: 2px;
	margin-right: 5px;
	font-size: 20px;
}

.back-without-links {
	margin-top: 25px;
}

@media (max-width: 767px) {
	.form-title {
		width: 100%
	}

	.payment-link-wrapper {
		margin-right: 0;
	}

	.order-link.fas {
		display: inline-block;
	}

	.back-without-links {
		margin-top: 5px;
	}

	.qr-image {
		position: unset;
		margin: 20px auto;
	}
}
</style>



// WEBPACK FOOTER //
// ClientPay.vue?62668fd4